<template>
  <div>
    <AppHeader />
    <v-overlay :value="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>
    <br />
    <br />
    <br />
    <h1 style="text-align: center" class="mb-6 grey--text text--darken-2 font-weight-regular">Bienvenido {{ name }}</h1>
    <v-container>
      <!-- Stats Row -->
      <v-row>
        <!-- Aspirantes -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="rideone d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-account-group</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Aspirantes</h4>
                <h2 class="text-right grey--text text--darken-2">{{ aspirantes }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Cargadores -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridetwo d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-account-group</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Cargadores</h4>
                <h2 class="text-right grey--text text--darken-2">{{ cargadores }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Honor Salida -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4" v-if="VDD || VDI">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridetwo d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-account-star</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Honor Salida</h4>
                <h2 class="text-right grey--text text--darken-2">{{ honor_salida }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Honor Entrada -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4" v-if="VDD || VDI">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridetwo d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-account-star</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Honor Entrada</h4>
                <h2 class="text-right grey--text text--darken-2">{{ honor_entrada }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Honor Extraordinario -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4" v-if="VDI">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridetwo d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-star-circle</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Honor Extra.</h4>
                <h2 class="text-right grey--text text--darken-2">{{ honor_extraordinario }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Honor Mujeres 1 -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4" v-if="JDC > 0">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridetwo d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-human-female</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Honor Mujeres 1</h4>
                <h2 class="text-right grey--text text--darken-2">{{ honor_mujeres1 }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Honor Mujeres 2 -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4" v-if="JDC > 0">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridetwo d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-human-female</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Honor Mujeres 2</h4>
                <h2 class="text-right grey--text text--darken-2">{{ honor_mujeres2 }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Turnos -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridethree d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-swap-vertical</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Turnos</h4>
                <h2 class="text-right grey--text text--darken-2">{{ turnos }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Sangrias -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridefour d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-account-multiple</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Sangrías</h4>
                <h2 class="text-right grey--text text--darken-2">{{ sangrias }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- Recaudación -->
        <v-col cols="12" sm="6" md="4" class="mb-2 mt-4">
          <v-card class="inforide" elevation="2">
            <v-row no-gutters class="fill-height">
              <v-col cols="4" class="ridefive d-flex justify-center align-center">
                <v-icon size="50" color="white">mdi-piggy-bank</v-icon>
              </v-col>
              <v-col cols="8" class="fontsty d-flex flex-column justify-center pr-4">
                <h4 class="text-right grey--text text--darken-2">Recaudación</h4>
                <h2 class="text-right grey--text text--darken-2">{{ recaudacion | moneyFormat }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

      </v-row>
      
      <!-- Charts Row -->
      <v-row class="mt-8">
        <v-col cols="12" md="8" offset-md="2">
          <v-card class="chart-card" elevation="4">
            <v-card-text>
              <h3 class="text-center grey--text text--darken-2 mb-4 font-weight-medium">Distribución de Participantes</h3>
              <ParticipantesChart v-if="chartDataReady" :chartData="participantesData" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
    <v-dialog v-model="showSessionExpiredDialog" max-width="400">
      <v-card>
        <v-card-title>¡Sesión expirada!</v-card-title>
        <v-card-text>Tu sesión ha expirado. Por favor, inicia sesión nuevamente.</v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="redirectToLogin">Iniciar sesión</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderC.vue";
import ParticipantesChart from "@/components/ParticipantesChart.vue";
import { ref } from "vue";
import axios from "axios";
import { EventBus } from "@/utils/eventBus";

// eslint-disable-next-line no-unused-vars
const variants = ["elevated", "flat", "tonal", "outlined"];
// eslint-disable-next-line no-unused-vars
const color = ref("indigo");

export default {
  name: "DashboardView",
  filters: {
    moneyFormat(value) {
      // Formatear el valor como "money" y separar por comas
      return "Q." + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data: () => ({
    VDD: false,
    JDC: false,
    VDI: false,
    showSessionExpiredDialog: false,
    honor_salida: 0,
    honor_entrada: 0,
    honor_extraordinario: 0,
    honor_mujeres1: 0,
    honor_mujeres2: 0,
    aspirantes: 0,
    cargadores: 0,
    turnos: 0,
    sangrias: 0,
    recaudacion: 0,
    loading: true,
    username: "", 
    name: "", 
    chartDataReady: false,
    participantesData: {}
  }),
  components: {
    AppHeader,
    ParticipantesChart
  },
  mounted: function () {
    this.initialize();



    // Escuchar evento desde el EventBus
    // Escuchar evento desde el EventBus
    EventBus.$on("procesionChanged", () => {
      if (this.$route.path === "/dashboard") {
        this.initialize();
      }
    });
  },
  beforeDestroy() {
    // Limpiar el listener cuando se destruya el componente
    EventBus.$off("procesionChanged", this.initialize);
  },
  methods: {
    async setHermandad() {
      // Esperar hasta que la cookie 'hermandad' esté disponible (por el delay del getProfile en el Login)
      while (!this.$cookies.get("hermandad")) {
        await new Promise((resolve) => setTimeout(resolve, 500));
      }

      const hermandad = this.$cookies.get('hermandad');

      if (hermandad === "Virgen de dolores") {
        this.VDD = true;
        this.JDC = false;
        this.VDI = false;
      } else if (hermandad === "Jesús Nazareno de la caída") {
        this.VDD = false;
        this.JDC = true;
        this.VDI = false;
      } else if (hermandad === "Hermandad Virgen de dolores Infantil") {
        this.VDI = true;
        this.VDD = false;
        this.JDC = false;
      } else if (hermandad === "Hermandad Pruebas") {
        this.VDI = true;
        this.VDD = true;
        this.JDC = true;
      } else {
        this.VDI = false;
        this.VDD = false;
        this.JDC = false;
      }
    },
    async initialize() {
      await this.setHermandad();
      await this.validateToken();
      await this.obtieneRegistros();

    },
    redirectToLogin() {
      // Redirigir al usuario al componente de inicio de sesión
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }

      //localStorage.removeItem('token');
      //localStorage.removeItem('user');
      //localStorage.removeItem('username');
      //localStorage.removeItem('name');
      this.$router.push("/");
    },
    validateToken() {
      //const token = localStorage.token
      const token = this.$cookies.get("token");
      this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      // Configuración para la solicitud GET con el token en el encabezado Authorization
      // Realizar solicitud GET a la API original con el token en el encabezado
      return axios
        .get(apiUrl)
        .then((response) => {
          const username = response.data.decoded.username;
          const name = response.data.decoded.given_name + " " + response.data.decoded.family_name;

          this.$cookies.set("username", username, "1d", "", "", true, "Strict");
          this.$cookies.set("name", name, "1d", "", "", true, "Strict");

          //localStorage.username = response.data.decoded.username;
          //localStorage.name = response.data.decoded.given_name + ' ' + response.data.decoded.family_name
          this.username = username;
          this.name = name;
          this.validToken = true;
        })
        .catch(() => {
          this.validToken = false;
          this.showSessionExpiredDialog = true;
          // console.error(error)
          // console.error('Error al obtener datos de la API', error);
          this.loading = false; // Desactivar animación de carga en caso de error
          //localStorage.clear
          this.clearAllCookies();
          // this.$router.push('/');
        });
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
    },
    async obtieneRegistros() {
      this.loading = true; // Desactivar animación de carga
      this.aspirantes = 0;
      this.cargadores = 0;
      this.turnos = 0;
      this.sangrias = 0;
      this.recaudacion = 0;

      // Esperar hasta que la cookie 'ProcesionID' esté disponible
      while (!this.$cookies.get("ProcesionID")) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      const apiUrl = `https://pc61cf7yyj.execute-api.us-east-1.amazonaws.com/dev/api/dashboard/${this.$cookies.get("ProcesionID")}?usuarioResponsable=${this.$cookies.get(
        "username"
      )}`;
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      try {
        const response = await axios.get(apiUrl, config);

        // Validar que la respuesta y los datos existen
        if (response.data && response.data.records && response.data.records.length > 0) {
          const record = response.data.records[0];
          this.aspirantes = record.aspirantes || 0;
          this.cargadores = record.cargadores || 0;
          this.turnos = record.turnos || 0;
          this.sangrias = record.sangrias || 0;
          this.recaudacion = record.recaudacion || 0;
          this.honor_entrada = record.honor_entrada || 0;
          this.honor_salida = record.honor_salida || 0;
          this.honor_mujeres1 = record.honor_mujeres1 || 0;
          this.honor_mujeres2 = record.honor_mujeres2 || 0;
          this.honor_extraordinario = record.honor_extraordinario || 0;

          this.updateChartData();
        } else {
          console.warn("La API no devolvió registros válidos");
        }
      } catch (error) {
        console.error("Error al obtener datos de la API", error);
      } finally {
        this.loading = false; // Desactivar animación de carga
      }
    },
    updateChartData() {
      // Build datasets dynamically based on visible variables
      const labels = [];
      const values = [];
      const colors = [];

      labels.push("Cargadores"); values.push(this.cargadores); colors.push("#A389F4");
      labels.push("Aspirantes"); values.push(this.aspirantes); colors.push("#6FCF97");

      if (this.VDD || this.VDI) {
        labels.push("Honor Salida"); values.push(this.honor_salida); colors.push("#56CCF2");
        labels.push("Honor Entrada"); values.push(this.honor_entrada); colors.push("#F2C94C");
      }
      
      if (this.VDI) {
        labels.push("Honor Extra."); values.push(this.honor_extraordinario); colors.push("#F2994A");
      }

      if (this.JDC > 0) {
        labels.push("Honor M1"); values.push(this.honor_mujeres1); colors.push("#EB5757");
        labels.push("Honor M2"); values.push(this.honor_mujeres2); colors.push("#BB6BD9");
      }

      this.participantesData = {
        labels: labels,
        datasets: [
          {
            backgroundColor: colors,
            borderWidth: 0,
            data: values,
          }
        ]
      };
      this.chartDataReady = true;
    }
  },
};
</script>

<style scoped>
.inforide {
  box-shadow: 0 10px 20px rgba(0,0,0,0.05) !important;
  background-color: white;
  border-radius: 12px;
  height: 125px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.inforide:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
}

.chart-card {
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
  padding: 10px;
}

.rideone {
  background: linear-gradient(135deg, #6cc785 0%, #46a060 100%);
  border-radius: 12px 0px 0px 12px;
  text-align: center;
  height: 125px;
}

.ridetwo {
  background: linear-gradient(135deg, #9a75fe 0%, #7650dc 100%);
  border-radius: 12px 0px 0px 12px;
  text-align: center;
  height: 125px;
}

.ridethree {
  background: linear-gradient(135deg, #4ebce5 0%, #2997c0 100%);
  border-radius: 12px 0px 0px 12px;
  text-align: center;
  height: 125px;
}

.ridefour {
  background: linear-gradient(135deg, #fb723e 0%, #d8501c 100%);
  border-radius: 12px 0px 0px 12px;
  text-align: center;
  height: 125px;
}

.ridefive {
  background: linear-gradient(135deg, #e4eb41 0%, #c1c822 100%);
  border-radius: 12px 0px 0px 12px;
  text-align: center;
  height: 125px;
}

.fontsty {
  margin-right: -15px;
}

.fontsty h2 {
  color: #4a4a4a;
  font-size: 38px;
  font-weight: 600;
  margin-top: 10px;
  text-align: right;
  margin-right: 30px;
  line-height: 1.1;
}

.fontsty h4 {
  color: #8c8c8c;
  font-size: 18px;
  font-weight: 500;
  margin-top: 0px;
  text-align: right;
  margin-right: 30px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
